<template>
  <div class="mx-2 ">
    <v-card class="mt-2">
      <v-row>
        <v-col cols="12">
          <CollegeEvaluationReviewCommitteeDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    CollegeEvaluationReviewCommitteeDataTable: () =>
      import(
        "../../components/Utils/CollegeEvaluationReviewCommitteeDataTable.vue"
      ),
  },
  created() {
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
  mounted() {},
  data: () => ({
    typeData: [],
    action: null,
    hasHead: false,
  }),
  methods: {},
};
</script>

<style></style>
